import * as React from 'react';
import { useSelector } from 'react-redux';

import { ACCOUNT_TYPE_NAME } from '../../../constants/accountTypeName';
import { currentOpenChatSelector } from '../../../selectors';

export const useFullscreenGalleryUserName = (userId: number): string => {
  const currentChat = useSelector(currentOpenChatSelector);
  const users = currentChat?.users || [];

  const { name, agencyName, agentName, agentAccountType } = users.find(user => user.userId === userId) || {};

  const userName = React.useMemo(() => {
    return name || agencyName || agentName;
  }, [name, agencyName, agentName]);

  const userTypeName = React.useMemo(() => {
    if (!userId) {
      return '';
    }

    return agentAccountType ? `${ACCOUNT_TYPE_NAME[agentAccountType]} (id ${userId})` : `Пользователь (id ${userId})`;
  }, [agentAccountType, userId]);

  return userName || userTypeName;
};
